import React, { Component } from 'react'

export default class About extends Component {
    render() {
        return (
            <div>
                <h1>This is about page</h1>
                <a href="https://raw.githubusercontent.com/BestBuyAPIs/open-data-set/master/categories.json" download>Download</a>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/About/About.js